import type {ImageLoaderProps} from 'next/image';
import {imageLoader as sanityImageLoader} from 'next-sanity/image';

/** next/image loader: Sanity CDN images are resized by Sanity; local static files are served as-is. */
const imageLoader = (props: ImageLoaderProps) => {
  if (props.src.startsWith('https://cdn.sanity.io/')) {
    return sanityImageLoader(props);
  }
  return `${props.src}?w=${props.width}`;
};

export default imageLoader;
